export const SAVE_HOTSITE_CHALLENGES_DATA = 'SAVE_HOTSITE_CHALLENGES_DATA'
export const SAVE_HOTSITE_EVENTS_DATA = 'SAVE_HOTSITE_EVENTS_DATA'

const saveHotsiteChallenges = (hotsiteChallenges: any): any => {
  return {
    type: SAVE_HOTSITE_CHALLENGES_DATA,
    payload: hotsiteChallenges
  }
}

const saveHotsiteEvents = (hotsiteEvents: any): any => {
  return {
    type: SAVE_HOTSITE_EVENTS_DATA,
    payload: hotsiteEvents
  }
}

export { saveHotsiteChallenges, saveHotsiteEvents }
